import api from './api';
import type {
  Role,
  RoleDetail,
  ResourceCatalogEntry,
  CreateRolePayload,
  UpdateRoleMetadataPayload,
  Permission,
} from '../types/role';

export const roleService = {
  list: async (): Promise<Role[]> => {
    const { data } = await api.get<{ data: Role[] }>('/roles');
    return data.data;
  },

  catalog: async (): Promise<ResourceCatalogEntry[]> => {
    const { data } = await api.get<{ resources: ResourceCatalogEntry[] }>('/roles/catalog');
    return data.resources;
  },

  getById: async (id: string): Promise<RoleDetail> => {
    const { data } = await api.get<RoleDetail>(`/roles/${id}`);
    return data;
  },

  create: async (payload: CreateRolePayload): Promise<Role> => {
    const { data } = await api.post<Role>('/roles', payload);
    return data;
  },

  updateMetadata: async (id: string, payload: UpdateRoleMetadataPayload): Promise<void> => {
    await api.put(`/roles/${id}`, payload);
  },

  delete: async (id: string): Promise<void> => {
    await api.delete(`/roles/${id}`);
  },

  replacePermissions: async (id: string, permissions: Permission[]): Promise<void> => {
    await api.put(`/roles/${id}/permissions`, { permissions });
  },

  resetDefaults: async (id: string): Promise<void> => {
    await api.post(`/roles/${id}/reset-defaults`);
  },
};
